module.exports = __webpack_public_path__ + "img/banner.e495e234.png";